// extracted by mini-css-extract-plugin
export default {"search__input":"SearchPage_search__input__rF-Gy"};